export enum LanguageEnum {
  EN = 'EN',
  FR = 'FR',
  DE = 'DE',
  LU = 'LU',
  BG = 'BG',
  HR = 'HR',
  CS = 'CS',
  NL = 'NL',
  ET = 'ET',
  FI = 'FI',
  EL = 'EL',
  HU = 'HU',
  IS = 'IS',
  IT = 'IT',
  LV = 'LV',
  LT = 'LT',
  NO = 'NO',
  PL = 'PL',
  PT = 'PT',
  RO = 'RO',
  SK = 'SK',
  SL = 'SL',
  ES = 'ES',
  SV = 'SV',
}
